import React from 'react';
import './device.scss';

interface DeviceProps {
  icon: string;
  name: string;
  functionality: string;
  active: boolean;
  onClick: () => void;
}
const Device = ({ icon, name, functionality, active, onClick }: DeviceProps) => {
  return (
    <div className={`device ${active && 'active'}`}>
      <div className={`icon-container ${active && 'active'}`} onClick={onClick}>
        <img src={icon}></img>
      </div>
      <p className="device-name">{name}</p>
      <p className="device-text">{functionality}</p>
    </div>
  );
};

export default Device;
